<!--
 * @Descripttion: 轮播表弹窗
 * @Author: zenghua.wang
 * @Date: 2021-10-25 15:27:40
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-06 10:48:40
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
  >
    <el-form
      ref="form"
      size="small"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >
      <el-form-item
        label="选择字段"
        prop="prop"
      >
        <el-select
          v-model="form.prop"
          clearable
          filterable
          allow-create
          default-first-option
          :popper-append-to-body="false"
          placeholder="请选择"
          @change="setFormProp"
        >
          <el-option
            v-for="feild in main.apiFieldList"
            :key="feild.value"
            :label="feild.label"
            :disabled="feild.disabled"
            :value="feild.label"
          ></el-option>
        </el-select>
        <div class="xa-form-tips">备注: 若没有可供选择的字段，可以手动输入！</div>
      </el-form-item>

      <el-form-item
        label="重命名"
        prop="label"
      >
        <el-input
          style="width: 188px"
          v-model="form.label"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item
        label="字段类型"
        prop="type"
      >
        <el-radio-group
          v-model="form.type"
          size="small"
        >
          <el-radio
            v-for="(item, index) in options.typeList"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="列宽">
        <el-input
          style="width:188px"
          v-model="form.width"
          placeholder="请输入"
        />
        <div class="xa-form-tips">备注: 宽度支持为 auto 或者数字</div>
      </el-form-item>

      <el-form-item label="对齐方式">
        <el-select
          v-model="form.align"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in options.alignList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="form.color"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <!-- <el-form-item label="链接地址">
        <el-input
          placeholder="如：http://www.wiseloong.com?id=${id}&name=${name}"
          style="width: 600px"
          v-model="form.url"
        >
        </el-input>
        <div class="xa-form-tips">备注: 输入完整(http://www.xxxx)的地址可以在新窗口中打开！</div>
      </el-form-item> -->

      <el-form-item
        label="下拉字典"
        v-if="selectType.includes(form.type)"
      >
        <el-radio-group
          v-model="form.dicFrom"
          size="mini"
        >
          <el-radio-button
            v-for="(item, index) in options.selectList"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <!-- 静态字典 -->
      <el-form-item
        label="静态字典"
        v-if="selectType.includes(form.type) && form.dicFrom === '静态'"
      >
        <dictory-select
          v-if="form.type === 'select'"
          :dicData="form.dicData"
          @change="updateDictory"
        />

        <dictory-cascader
          v-if="form.type === 'cascader'"
          :dicData="form.dicData"
          @change="updateDictory"
        />
      </el-form-item>

      <!-- 接口获取 -->
      <template v-if="form.dicFrom === '动态'">
        <el-form-item label="字典接口">
          <el-input
            v-model="form.dicUrl"
            style="width:500px"
          />
        </el-form-item>

        <el-form-item label="请求方式">
          <el-select
            style="width:188px"
            size="small"
            clearable
            placeholder="请选择"
            v-model="form.dicMethod"
          >
            <el-option
              v-for="(item,index) in options.methodList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <span slot="footer">
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  predefineColors,
  theme,
  component
} from '@/dragComponents/model/default.js'
import { isEmpty } from '@/dragComponents/utils'

import dictorySelect from '@/dragComponents/config/dictory/select'
import dictoryCascader from '@/dragComponents/config/dictory/cascader'

export default {
  name: 'scrollboad-field-dialog',
  inject: ['main'],
  components: {
    dictorySelect,
    dictoryCascader
  },
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      form: {},
      // 级联字典
      selectType: ['select', 'cascader'],
      options: {
        typeList: component.searchType,
        selectList: component.selectType,
        alignList: component.alignType
      },
      rules: {
        prop: [{ required: true, message: '请选择字段', trigger: 'blur' }],
        type: [{ required: true, message: '请选择字段类型', trigger: 'blur' }]
      }
    }
  },
  watch: {
    column(val) {
      this.form = val
    },
    form: {
      handler(val) {
        this.$emit('update:column', val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 选择字段
    setFormProp(e) {
      if (isEmpty(e)) return
      let label = isEmpty(e.label) ? e : e.label
      if (isEmpty(e.label)) {
        this.$nextTick(() => {
          this.form.prop = label
        })
      } else {
        this.form.prop = label
      }
    },
    // 更新字典
    updateDictory(list) {
      this.form.dicData = list
    },
    onSubmit() {
      this.$refs.form.validate((bool) => {
        if (bool) {
          this.$emit('change', this.form)
          this.dialog.show = false
        }
      })
    }
  }
}
</script>
